<table [ngClass]="classes" class="table-custom-striped">
  @if (description?.headerItems) {
    <thead>
      <tr>
        @for (item of description.headerItems; track item; let i = $index) {
          <th [ngClass]="cellClasses[i]">
            @if (item.infoTextCode) {
              <mwe-info-text [infoTextCode]="item.infoTextCode">
                {{ item.label | translate }}
              </mwe-info-text>
            }
            @if (!item.infoTextCode) {
              {{ item.label | translate }}
            }
          </th>
        }
      </tr>
    </thead>
  }
  <tbody>
    @for (item of description?.dataItems; track item) {
      <tr>
        @for (column of item; track column; let i = $index) {
          <td [ngClass]="cellClasses[i] ? cellClasses[i] : ''">{{ column }}</td>
        }
      </tr>
    }
    <ng-content select="[slot='table-rows']" />
  </tbody>
  <tfoot>
    <ng-content select="[slot='table-footer']" />
  </tfoot>
  <ng-content />
</table>
